import * as React from "react";

interface Props {
  color?: string;
}

export const WalletIcon = (props: Props) => (
  <svg
    width={16}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13 4.5H3A1.5 1.5 0 0 0 1.5 6v6A1.5 1.5 0 0 0 3 13.5h10a1.5 1.5 0 0 0 1.5-1.5V6A1.5 1.5 0 0 0 13 4.5Z"
      stroke={props.color ?? "#666"}
      strokeLinejoin="round"
    />
    <path
      d="M12.855 4.5v-.938A1.563 1.563 0 0 0 11 2.028L2.77 3.433A1.562 1.562 0 0 0 1.5 4.969V6.5"
      stroke={props.color ?? "#666"}
      strokeLinejoin="round"
    />
    <path
      d="M11.5 10a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
      fill={props.color ?? "#666"}
    />
  </svg>
);
